import { ColDef, ColGroupDef, ColumnState, GridApi } from '@ag-grid-community/core';

import { ColumnChooserNode } from '@shared/components/column-chooser/components/column-chooser-modal/model/column-chooser.model';
import { ColumnChooserService } from '@shared/components/column-chooser/services/column-chooser.service';

export function applyColumnDefsWithPinState(
  gridApi: GridApi,
  columnDefs: (ColDef | ColGroupDef)[],
  configKey: string,
  excludeColumns: string[] = []
) {
  const chooserService = new ColumnChooserService(gridApi);
  const config = chooserService.getTypeSafeColumnChooserConfig(configKey, excludeColumns);
  const columnState = buildColumnStateFromChooserConfig(columnDefs, config);

  gridApi.applyColumnState({
    state: columnState,
  });
}

export function mergePinnedStateIntoColumnDefs(
  columnDefs: (ColDef | ColGroupDef)[],
  chooserNodes: ColumnChooserNode[]
): (ColDef | ColGroupDef)[] {
  return columnDefs.map((def) => {
    const match = chooserNodes.find(
      (n) =>
        n.field && ((def as ColDef).field === n.field || (def as ColGroupDef).groupId === n.field)
    );

    if (!match) return def;

    if ('children' in def && def.children && match.children) {
      return {
        ...def,
        children: mergePinnedStateIntoColumnDefs(def.children, match.children),
      };
    }

    if ('field' in def && typeof match.pinned !== 'undefined') {
      return {
        ...def,
        hide: !match.checked,
        pinned: match.checked && match.pinned ? 'left' : undefined,
      };
    }

    return def;
  });
}

function buildColumnStateFromChooserConfig(
  columnDefs: (ColDef | ColGroupDef)[],
  chooserNodes: ColumnChooserNode[]
): ColumnState[] {
  const columnState: ColumnState[] = [];

  const processColumnDefs = (defs: (ColDef | ColGroupDef)[], nodes: ColumnChooserNode[]) => {
    defs.forEach((def) => {
      const match = nodes.find(
        (n) =>
          n.field && ((def as ColDef).field === n.field || (def as ColGroupDef).groupId === n.field)
      );

      if (match) {
        if ('children' in def && def.children && match.children) {
          processColumnDefs(def.children, match.children);
        } else if ('field' in def && def.field && typeof match.pinned !== 'undefined') {
          columnState.push({
            colId: def.field,
            hide: !match.checked,
            pinned: match.checked && match.pinned ? 'left' : undefined,
          });
        }
      }
    });
  };

  processColumnDefs(columnDefs, chooserNodes);

  return columnState;
}
